import { throwError as observableThrowError } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { WrapperCollegamentoUnitaDocumentariaDTO } from "../dto/wrapper-collegamento-unita-documentariaDTO";
import { Observable } from "rxjs";
import { env } from "@env/environment";
import { catchError, map } from "rxjs/operators";
import { MapperWrapperCollegamentoUD } from "../mapper/mapper-wrapper-collegamento-ud";
import { WrapperCollegamentoUnitaDocumentariaVO } from "../vo/wrapper-collegamento-unita-documentariaVO";
import { CollegamentoUnitaDocumentariaDTO } from "../dto/collegamento-unita-documentariaDTO";
import { ModaleErroreStore } from "../store/modale-errore.store";

@Injectable({
  providedIn: "root",
})
export class CollegamentoUnitaDocumentariaService {
  constructor(
    private httpClient: HttpClient,
    private mapperWrapperCollegamentoUD: MapperWrapperCollegamentoUD,
    private modaleErroreStore: ModaleErroreStore
  ) {}

  getCollegamenti(
    id: String,
    dettaglioWrapped: boolean
  ): Observable<WrapperCollegamentoUnitaDocumentariaVO[]> {
    let url =
      env.DOCUMENTALE_API_URL_BASE +
      env.URL_UNITA_DOCUMENTARIA +
      id +
      "/collegamenti";

    const params = new HttpParams().set(
      "dettaglioWrapped",
      dettaglioWrapped.toString()
    );

    return this.httpClient
      .get<WrapperCollegamentoUnitaDocumentariaDTO[]>(url, { params: params })
      .pipe(
        map((response: WrapperCollegamentoUnitaDocumentariaDTO[]) =>
          this.mapperWrapperCollegamentoUD.convertListDtoToVo(response)
        ),
        catchError((_) => Observable.of([]))
      );
  }

  aggiungiCollegamento(collegamento: CollegamentoUnitaDocumentariaDTO) {
    let url =
      env.DOCUMENTALE_API_URL_BASE +
      env.URL_UNITA_DOCUMENTARIA +
      collegamento.idUno +
      "/collega/" +
      collegamento.idDue;
    console.log(
      "[CollegamentoUnitaDocumentariaService][aggiungiCollegamento] id1 e id2: ",
      collegamento.idDue,
      collegamento.idUno + " datiinPost: ",
      collegamento
    );
    return this.httpClient.put<void>(url, collegamento).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  rimuoviCollegamento(id1: string, id2: string) {
    let url =
      env.DOCUMENTALE_API_URL_BASE +
      env.URL_UNITA_DOCUMENTARIA +
      id1 +
      "/collega/" +
      id2;
    console.log(
      "[CollegamentoUnitaDocumentariaService][rimuoviCollegamento] id1 e id2: ",
      id1,
      id2
    );
    return this.httpClient.delete<void>(url).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }
}
